function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { isProperty } from 'common/query-builder/query-block/properties-menu/types';
import { SelectReact } from 'common/components/select';
import { ButtonSize } from 'common/components/button/constants';
import { SelectTheme } from 'common/components/select/constants';
import { Behavior } from 'common/types/reports/query';
import { DEFAULT_REVENUE_CHANGE_BEHAVIOR } from 'common/query-builder/query-entry-section/row-types/behavior/utils';
import { Offset } from '../offset';
import styles from './index.module.styl';
import { REVENUE_CHANGE_TYPES } from './constants';
function RevenueChange(_ref: {
  behavior: Behavior;
  onChange: (behavior: Behavior) => void;
}) {
  let {
    behavior,
    onChange
  }: {
    behavior: Behavior;
    onChange: (behavior: Behavior) => void;
  } = _ref;
  const changeType = behavior.changeType;
  return <>
      <Offset value={behavior.offset} onChange={offset => {
      onChange(_objectSpread(_objectSpread({}, behavior), {}, {
        offset
      }));
    }} data-sentry-element="Offset" data-sentry-source-file="index.tsx" />
      {behavior.behaviorType === DEFAULT_REVENUE_CHANGE_BEHAVIOR.behaviorType && <div className={styles.changeType}>
          <div className={styles.text}>Change Type is</div>
          <SelectReact theme={SelectTheme.QbSubitem} size={ButtonSize.Small} menuWidth={140} onChange={_ref2 => {
        let {
          detail: {
            item
          }
        } = _ref2;
        onChange(_objectSpread(_objectSpread({}, behavior), {}, {
          changeType: item.value
        }));
      }} sections={[{
        // remove `flat` in the rev change
        items: REVENUE_CHANGE_TYPES.filter(revenueChangeType => revenueChangeType.value !== "flat").map(item => ({
          isSelected: changeType === item.value,
          label: item.label,
          value: item.value
        }))
      }]} />
        </div>}
    </>;
}
/**
 * Revenue block is displayed when "Recurring Revenue Change" (computed property) is selected
 */
export function RevenueChangeBlock(props: {
  behavior: Behavior;
  onChange: (behavior: Behavior) => void;
}) {
  var _props$behavior, _props$behavior2;
  if (!isProperty((_props$behavior = props.behavior) === null || _props$behavior === void 0 ? void 0 : _props$behavior.property)) {
    return null;
  }
  if (!((_props$behavior2 = props.behavior) !== null && _props$behavior2 !== void 0 && _props$behavior2.offset)) {
    return null;
  }
  return <RevenueChange behavior={props.behavior} onChange={changedBehavior => {
    props.onChange(changedBehavior);
  }} data-sentry-element="RevenueChange" data-sentry-component="RevenueChangeBlock" data-sentry-source-file="index.tsx" />;
}